import { Box, DialogContent, DialogTitle, Stack } from "@mui/material"
import { PropertyBox } from "lib/@components/property-box"
import { OkCancel } from "lib/@components/okCancel"

export function DialogBox({
    Actions = OkCancel,
    actions,
    sx,
    spacing = 1,
    title,
    className = "dialogBox",
    children,
    containerProps,
    "data-cy": dataCy,
    ...props
}) {
    return (
        <Stack
            sx={{ overflow: "hidden", ...sx }}
            className={className}
            spacing={spacing}
            {...containerProps}
            data-cy={dataCy}
        >
            {/* Only render the title bar when a title is supplied; an empty DialogTitle otherwise
                leaves blank header space and an empty heading for assistive tech. */}
            {title && <DialogTitle>{title}</DialogTitle>}
            <DialogContent>
                <PropertyBox>{children}</PropertyBox>
            </DialogContent>
            <Box flex={1} />
            <Actions {...props} children={actions} />
        </Stack>
    )
}
